import L from "leaflet";
import { shape } from "./shapes";
import { getNode } from "../overlaysUtils";
const formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0})
const colors = (codeInsee) => codeInsee != '75056'
    ? ["#EBED8C", "#EADA4A", "#E3B130", "#FF0000", "#8E0000"]
    : ["#EAEC83", "#DBDB04", "#FFCE03", "#FD9A01", "#D94500", "#FF2C05", "#F00505", "#980404", "#590303", "#230000"];

const getColorSector = (nb, fieldNamePrice, estimates, codeInsee) => {
    const thresholdsNb = codeInsee != '75056' ? 5 : 10;
    const prices = estimates.map(e => e[fieldNamePrice]);
    const part = (Math.max(...prices) - Math.min(...prices))/ thresholdsNb;
    const thresholds = Array.from({length: thresholdsNb}, (_, i) => Math.min(...prices) + (part*i)).filter(i => nb > i)

    return thresholds.length > 0 ? colors(codeInsee)[thresholds.length - 1] : colors(codeInsee)[0];
}

export const initMinimalMap = (mapElement, legendElement, outlineCity, locationInfos, layersPosition) => {
    //layers
    const grayScaleLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20
    });
    const arcgisLayer = L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        {
            attribution: '&copy; ESRI contributors',
        }
    );
    const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: '&copy; Esri'
    });
    const tileLayers = {
        [`<img id="gray-scale-layer" src="/img/layers/gray-scale-layer.png" alt="Carte en niveaux de gris"><p>Niveaux de gris</p>`] : grayScaleLayer,
        [`<img id="arcgis-layer" src="/img/layers/arcgis-layer.png" alt="Carte en vue plan"><p>Plan</p>`]: arcgisLayer,
        [`<img id="satellite-layer" src="/img/layers/satellite-layer.png" alt="Carte en vue satellite"><p>Satellite</p>`]: satelliteLayer
    };

    const layersControl = L.control.layers(tileLayers, null, {collapsed: false, position: layersPosition ? layersPosition : 'topright'}).addTo(mapElement);
    L.DomUtil.addClass(layersControl.getContainer(), 'layers-control');
    grayScaleLayer.addTo(mapElement);
    mapElement.on('baselayerchange', (e) => {
        layersControl.getContainer().querySelectorAll(`img[id$=layer]`).forEach(img => img.parentElement.parentElement.parentElement.classList.remove('selected'));
        let selectParent = (value) => layersControl.getContainer().querySelector(`img[id^=${value}]`).parentElement.parentElement.parentElement.classList.add('selected');
        (e.name).indexOf('gray-scale') !== -1 && selectParent('gray-scale');
        (e.name).indexOf('arcgis') !== -1 && selectParent('arcgis');
        (e.name).indexOf('satellite') !== -1 && selectParent('satellite');
    });
    layersControl.getContainer().addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target.tagName === 'DIV' || e.target.tagName === 'INPUT') {
            L.DomUtil.hasClass(layersControl.getContainer(), 'active') ? L.DomUtil.removeClass(layersControl.getContainer(), 'active') : L.DomUtil.addClass(layersControl.getContainer(), 'active');
        }
    });
    document.addEventListener('click', () => L.DomUtil.hasClass(layersControl.getContainer(), 'active') && L.DomUtil.removeClass(layersControl.getContainer(), 'active'));

    //zoom
    L.control.zoom({position: "bottomright"}).addTo(mapElement);

    //city outlines
    outlineCity && outlineCity.addTo(mapElement);

    //marker if address or outlineCity bounds
    positionMarker(locationInfos.address, mapElement, outlineCity);

    //fitBounds
    let bounds;
    if(getNode(locationInfos, ['address', 'lat']) && getNode(locationInfos, ['address', 'lon'])){
        bounds = L.latLngBounds([locationInfos.address.lat + 0.01, locationInfos.address.lon + 0.01], [locationInfos.address.lat - 0.01, locationInfos.address.lon - 0.01]);
    } else {
        bounds = outlineCity.getBounds();
    }

    // limit bounds
    if (outlineCity) {
        mapElement.setMaxBounds(outlineCity.getBounds().pad(3.0));
    } else {
        mapElement.setMaxBounds(bounds.pad(1.0));
    }

    //init legend with outline city
    if(legendElement && locationInfos){
        if(locationInfos.com){
            legendElement.onAdd = () => {
                let div = L.DomUtil.create('div', 'leaflet-legend m-2 p-2 bg-white');
                div.style.width = '300px';
                let locationList = [{label: 'Contour de la ville', shape: 'dotted', color: '#000'}];
                locationInfos.address && locationList.push({label: (locationInfos.address.addressLabel || `[${locationInfos.address.lat}, ${locationInfos.address.lon}]`), shape: 'marker', color: '#000'});
                div.appendChild(legendGroup({id: 'locationInfos', label: locationInfos.com.libelle}, locationList));
                return div;
            }
        }
        legendElement.addTo(mapElement);
    }
}

//init outline city
export const initOutlineCity = (outlineCity) => {
    return L.geoJSON(outlineCity, {
        style: {
            color: "#000",
            weight: 2,
            fill: false,
            dashArray: "4"
        }
    })
}

// remove a single layer
export const removeLayer = (overlaysGroup, layer) => {
    let toRemove = overlaysGroup.getLayers().find(l => l.layerId === layer.id)
    if (toRemove) {
        overlaysGroup.removeLayer(toRemove);
    }
}

// remove a single legend
export const removeLayerLegend = (legend, layer) => {
    legend._container.replaceChildren(...Array.from(legend._container.childNodes).filter(c => c.id !== `${layer.id}-legend`));
}

export const addLayerLegend = (legend, position, selectedItem, legendList) => {
    const legendGrp = legendGroup(selectedItem, legendList);
    if (position >= legend._container.childNodes.length) {
        legend._container.appendChild(legendGrp)
    } else {
        legend._container.insertBefore(legendGrp, legend._container.childNodes[position])
    }
}

// replace legend layer
export const addLayertToLegend = (selectedItem, legendList, legendElement) => {
    clearLayerLegend(legendElement);
    if (selectedItem) {
        legendElement._container.appendChild(legendGroup(selectedItem, legendList));
    };
    
}

// remove legend layer & keep outline legend
export const clearLayerLegend = (legendElement) => {
    legendElement._container.replaceChildren(...Array.from(legendElement._container.childNodes).filter(c => c.id === 'locationInfos-legend'));
}

// create legend layer group
const legendGroup = (selectedItem, legendList) => {
    let div = L.DomUtil.create('div', 'example mb-3');
    div.id = `${selectedItem.id}-legend`;
    div.innerHTML = `
        <button type="button" class="collapse-handler text-left pl-0" data-toggle="collapse" data-target="#collapse-${selectedItem.id}" aria-expanded="false" aria-controls="#collapse-${selectedItem.id}">
            <span><strong>${selectedItem.label}</strong></span>
        </button>
        <div class="collapse collapse-wrapper show" id="collapse-${selectedItem.id}">
            ${(selectedItem.details) ? `<p>${selectedItem.details}</p>` : ''}
            ${legendList.map(l =>
                `<div class="d-flex align-items-start mt-1">
                    <span style="height:18px;width:18px">
                        <span class="h-100">
                            ${shape(l.shape, l.fillColor||l.color, l.color !== '#fff' ? l.color : '#000', l.strokeWidth, l.fillOpacity)}
                        </span>
                    </span>
                    <p class="my-0 px-2 col-11">${l.label}</p>
                </div>`
            ).join('')}
        </div>`
    return div;
};

// init legend modal
export const initModalLegend = (legendElement, locationInfos, mapElement, toggleCaption, buttonLabel) => {
    if(legendElement && locationInfos){
        legendElement.onAdd = () => {
            let btn = L.DomUtil.create('button', 'btn-modal map-infos');
            btn.innerHTML = `<svg aria-label="Infos" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path>
                            </svg>`;
            if (buttonLabel) {
                btn.innerHTML += `<span>${buttonLabel}</span>`;
            }
            btn.addEventListener('click', () => toggleCaption());
            return btn;
        }
        legendElement.addTo(mapElement);
    }
}

// init minimal legend
export const initMinimalLegend = (legendElement, legendList, mapElement) => {
    legendElement.onAdd = () => {
        let div = L.DomUtil.create('div', 'leaflet-legend m-2 p-2 bg-white text-dark');
        div.style.width = 'max-content';
        div.innerHTML = `<div>
            ${legendList.map(l =>
                `<div class="d-flex align-items-start mt-1">
                    <span style="height:18px;width:18px">
                        <span class="h-100">
                            ${shape(l.shape, l.fillColor||l.color, l.color !== '#fff' ? l.color : '#000', l.strokeWidth, l.fillOpacity)}
                        </span>
                    </span>
                    <p class="my-0 px-2">${l.label}</p>
                </div>`
            ).join('')}
        </div>`
        return div;
    }
    legendElement.addTo(mapElement);
}

//init isochrones
export const initIsochrones = (controlElement, legendElement, overlayGroupElement, mapElement, address) => {
    //init isochrone legend
    legendElement.onAdd = () => {
        let div = L.DomUtil.create('div', 'isochrones-legend m-2 p-2 bg-white hide ');
        div.style.width = '300px';
        return div;
    }
    legendElement.addTo(mapElement);

    controlElement.onAdd = () => {
        //init isochrone control
        let div = L.DomUtil.create('div', 'leaflet-control-isochrones m-2 p-1 bg-white d-flex flex-wrap justify-content-around');
        let baseUrl = `/api/isochrones?lat=${address.lat}&lon=${address.lon}&mode=`
        let isochronesList = [
            {id: 'none', name: 'Aucun'},
            {id: 'walk', name: 'À pied', url: `${baseUrl}walk&time=300,600,900`, img: '/img/map/man-walking.svg'},
            {id: 'bike', name: 'À vélo', url: `${baseUrl}bike&time=300,600,900`, img: '/img/map/bike.svg'},
            {id: 'car', name: 'En voiture', url: `${baseUrl}car&time=300,600,900`, maificon: 'maificon-berline'},
            {id: 'transit', name: 'En transports en commun', url: `${baseUrl}transit&time=300,600,900`, maificon: 'maificon-bus'} 
        ]
        div.innerHTML= `<span class='col-12'>Temps de trajet</span>`;

        isochronesList.forEach(item => {
            const btn = isochroneItem(item);
            btn.addEventListener('click', (e) => {
                document.querySelectorAll('.isochrones-item').forEach(i => i.classList.remove('active'));
                btn.classList.add('active');
                overlayGroupElement.clearLayers();
                clearLayerLegend(legendElement);
                mapElement.fitBounds(L.latLngBounds([address.lat + 0.03, address.lon + 0.03], [address.lat - 0.03, address.lon - 0.03]));
                if(item.id !== 'none'){
                    legendElement._container.classList.add('hide');
                    fetch(item.url)
                        .then(res => res.json())
                        .then(res => {
                            let colors = ['#00517b', '#058dac', '#01a6b5'];
                            const featuresFormatted =
                                res.features
                                    .sort((a, b) => a.properties.time - b.properties.time)
                                    .map((f, index) => ({
                                        ...f,
                                        style: {
                                            fillColor: colors[index],
                                            fillOpacity: 0.5,
                                            opacity: 0.7,
                                            color: colors[index],
                                            weight: 1
                                        }
                                    }));
                            const overlay = L.geoJSON({...res, features: featuresFormatted}, { style: (feature) => feature.style, interactive: false });
                            overlayGroupElement.addLayer(overlay);
                            overlay.bringToBack();
                            legendElement._container.appendChild(legendGroup(
                                {id: 'isochrones', label: item.name},
                                featuresFormatted.map(f => ({label: `${f.properties.time/60} minutes`, shape: 'square', color: f.style.color}))
                            ))
                            legendElement._container.classList.remove('hide');
                        })
                } else {
                    legendElement._container.classList.add('hide');
                }
            })
            div.appendChild(btn);
        })
        return div;
    }
    controlElement.addTo(mapElement);
}

// create isochrones item
const isochroneItem = (item) => {
    let btn = L.DomUtil.create('button', 'btn btn-icon isochrones-item m-1 p-1 border');
    btn.id = `${item.id}`;
    if(item.id !== 'none'){
        btn.innerHTML = item.img ? `<img src="${item.img}" alt="${item.name}" class='h-100 w-100'/>` : `<i class='maificon ${item.maificon}' aria-label=${item.name} aria-hidden='true'></i>`;
    } else {
        btn.innerHTML = item.name;
        btn.classList.add('active');
        btn.style.fontSize = '10px';
    }
    return btn;
}

// create L.control with options
export const createControl = (position, collapsed, collapsible) => {
    return L.control({
        position: position,
        collapsed: collapsed,
        collapsible: collapsible,
        disableMouseEvents: true,
        buttonHtml: '<span class="hide"></span>'
    })
}

// create generic map
export const createMap = (id) => {
    return L.map(`${id}-map`, {
        zoomControl: false,
        zoomSnap: 0.25,
        minZoom: 10,
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile
    });
}

//marker if address & fitBounds
export const positionMarker = (address, mapElement, outlineCity) => {
    const currentMarker = mapElement.getContainer().querySelector('.address-marker');
    currentMarker && currentMarker.remove();

    if (address && address.lat && address.lon) {
        const addressIcon = L.icon({
            iconUrl: '/img/map/aa-marker.svg',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
            popupAnchor: [0, -34],
            className: 'address-marker'
        });
        L.marker([address.lat, address.lon], { icon: addressIcon }).addTo(mapElement);
        mapElement.setView([address.lat, address.lon], 14);
    } else {
        mapElement.fitBounds(outlineCity.getBounds());
    }
}

//init immobilier
export const initImmobilierLegend = (legendElement, estimates, fieldNamePrice, codeInsee, mapElement) => {
    legendElement.onAdd = () => {
        let div = L.DomUtil.create('div', 'leaflet-legend mx-2 px-2 bg-white text-dark');
        div.style.width = '160px';
        div.innerHTML = `
            <div class="mb-3">
                <p class="font-weight-bold">Estimation des prix</p>
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <span class="text-secondary">Basse</span>
                        <span><strong>${formatter.format(Math.min(...estimates.map(e => e[fieldNamePrice])))} ${fieldNamePrice == 'est_prix' ? '' : '/m&sup2;'}</strong></span>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="text-secondary text-right">Haute</span>
                        <span><strong>${formatter.format(Math.max(...estimates.map(e => e[fieldNamePrice])))} ${fieldNamePrice == 'est_prix' ? '' : '/m&sup2;'}</strong></span>
                    </div>
                </div>
                <div class="estimate-colors-container">
                    ${colors(codeInsee).map(color => `<i class="estimate-color-item" style="--estimate-color: ${color}"></i>`).join('')}
                </div>
            </div>`
        return div;
    }
    legendElement.addTo(mapElement);
}

// mount immobilier layer
export const mountImmoFeatures = (geoJsonData, fieldNamePrice, codeInsee) => {
    const communes = geoJsonData.communes;
    const irisFeatures = geoJsonData.iris.features;
    irisFeatures.map(feature => {
        const { properties } = feature;
        const estimate = geoJsonData.estimates.find(e => e.num_iris === properties.codeIris)
        const multipleComs = communes && communes.features && (communes.features.length > 1);
        const commune = communes.features.find(c => properties.codeIris.startsWith(c.properties.com));
        const libelle = ((multipleComs && commune && properties.typeIris.code !== 'Z') ? commune.properties.libelle + ' - ' + properties.libelleIris : properties.libelleIris);

        feature.properties = {
            ...properties,
            prix_m2: estimate ? estimate[fieldNamePrice] : undefined,
            nb_ventes: estimate ? estimate.nb_ventes : undefined,
            color: estimate ? getColorSector(estimate[fieldNamePrice], fieldNamePrice, geoJsonData.estimates, codeInsee) : '#000',
            label: estimate ? `${formatter.format(estimate[fieldNamePrice])} / m²` : undefined,
            libelleIris: libelle
        }
        return feature;
    })
    return L.geoJSON(irisFeatures, {
        style: (feature) =>  ({
            color: feature.properties.color,
            weight: 1,
            fillOpacity: 0.7,
            fill: true,
        }),
        onEachFeature: (feature, layer) => layer.bindPopup(feature.properties.libelleIris ? `<p>${feature.properties.libelleIris}<br/>${feature.properties.label}</p>` : feature.properties.label)
    })
}